export default __webpack_public_path__ + "static/ls-mockups@2x-b783344c8d056dcb73d1751274b1c8b8.png";